// Phase 83t — Helper: resolve the canonical "watch live" URL for a match.
// v16.17 Phase C.28 — Ưu tiên `match_code` slug (bk-1, tk-2) → SEO friendly.
// v16.17 Phase C.31 — Path-based tab: `/athlete/tournaments/{tid}/livestream`.
import { matchToUrlParam } from "./matchUrlSlug";
import { tabCodeToSlug } from "./tournamentTabs";

export function liveMatchPath(match) {
  if (!match) return "/athlete/matches";
  const tid = match.tournamentId || match.tournament_id;
  const mid = match.id;
  if (tid && mid) {
    const slug = matchToUrlParam(match) || mid;
    return `/athlete/tournaments/${tid}/${tabCodeToSlug("livestream")}?match=${slug}`;
  }
  if (mid) return `/athlete/matches/${mid}/live`;
  return "/athlete/matches";
}
